module.exports = __webpack_public_path__ + "static/logoJ&P-24e3990d15fa1b9b1aa017d794f17e2c.jpg";